export var CardOverrides = function (theme) { return ({
    MuiCard: {
        root: {
            border: "1px solid ".concat(theme.palette.border.main),
        },
    },
    MuiCardContent: {
        root: {
            '&:last-child': {
                paddingBottom: undefined,
            },
        },
    },
    MuiCardHeader: {
        action: {
            marginBottom: theme.spacing(-1),
        },
    },
    MuiCardActionArea: {
        root: {
            '&:hover': {
                '& $focusHighlight': {
                    opacity: 0.12,
                },
            },
            '&$focusVisible': {
                '& $focusHighlight': {
                    opacity: 0,
                },
            },
        },
    },
}); };
//# sourceMappingURL=Card.overrides.js.map